// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EgMS","colBig":"styles_colBig__3Oxue","colSmall":"styles_colSmall__vitpm","shopifyNameWrapper":"styles_shopifyNameWrapper__1XicP"};